import type { ComponentProps } from 'react'
import { cn } from 'utils/cn'

export interface SpinnerProps extends ComponentProps<'div'> {
  size?: 'xsmall' | 'small' | 'medium' | 'big'
  className?: string
  backgroundClasses?: string
}

const Spinner = ({
  size = 'small',
  className,
  backgroundClasses,
}: SpinnerProps) => {
  return (
    <div
      // tell screenreaders this will change
      aria-live='polite'
      className={cn(
        'bg-loader-background text-primary-600 relative inline-block animate-spin rounded-full bg-top',
        {
          'h-[14px] w-[14px]': size === 'xsmall',
          'h-[20px] w-[20px]': size === 'small',
          'h-[36px] w-[36px]': size === 'medium',
          'h-[60px] w-[60px]': size === 'big',
        },
        className,
      )}
      data-testid='spinner_wrapper'
      role='status'
      style={
        {
          '--spinner-color': 'currentColor',
        } as React.CSSProperties
      }
    >
      <div
        className={cn(
          '!bg-loader-point absolute top-0 z-[100] inline-block rounded-full bg-no-repeat',
          {
            'bg-loader-size-xsmall left-[42%] h-[6px] w-[6px]':
              size === 'xsmall',
            'bg-loader-size-small left-[42%] h-2 w-2': size === 'small',
            'bg-loader-size-medium left-[43%] h-3 w-3': size === 'medium',
            'bg-loader-size-big left-[44%] h-3 w-3': size === 'big',
          },
        )}
        data-testid='spinner_background'
      />

      <div
        className={cn(
          'absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform rounded-full',
          'border-transparent bg-white',
          {
            'h-[11px] w-[11px]': size === 'small' || size === 'xsmall',
            'h-[22px] w-[22px]': size === 'medium',
            'h-[42px] w-[42px]': size === 'big',
          },
          backgroundClasses,
        )}
        data-testid='spinner_item'
      />
    </div>
  )
}

Spinner.displayName = 'Spinner'

export { Spinner }
